export default __webpack_public_path__ + "static/media/beginners_banner.4bfe8637.jpg";